import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Modal, Form, Row, Col } from 'react-bootstrap';
import Message from '../../shared_components/Message';
import Loader from '../../shared_components/Loader';

import {
  createJitaiVariable,
  updateJitaiVariable,
} from '../actions/jitaiActions';
import {
  JITAI_VARIABLE_CREATE_RESET,
  JITAI_VARIABLE_UPDATE_RESET,
} from '../constants/jitaiConstants';

const UpsertJitaiVariable = ({
  studyId,
  jitaiVariableList,
  updatedJitaiVariable,
}) => {
  const [show, setShow] = useState(false);
  const [code, setCode] = useState('');
  const [definition, setDefinition] = useState('');

  const dispatch = useDispatch();

  const jitaiVariableCreate = useSelector((state) => state.jitaiVariableCreate);
  const {
    loading: loadingCreate,
    error: errorCreate,
    success: successCreate,
  } = jitaiVariableCreate;

  const jitaiVariableUpdate = useSelector((state) => state.jitaiVariableUpdate);
  const {
    loading: loadingUpdate,
    error: errorUpdate,
    success: successUpdate,
  } = jitaiVariableUpdate;

  const isEditMode = !!updatedJitaiVariable;

  useEffect(() => {
    if (isEditMode && updatedJitaiVariable) {
      setCode(updatedJitaiVariable.code);
      setDefinition(updatedJitaiVariable.definition);
    }
  }, [isEditMode, updatedJitaiVariable]);

  useEffect(() => {
    if (successCreate || successUpdate) {
      setShow(false);
      setCode('');
      setDefinition('');
      dispatch({ type: JITAI_VARIABLE_CREATE_RESET });
      dispatch({ type: JITAI_VARIABLE_UPDATE_RESET });
    }
  }, [successCreate, successUpdate, dispatch]);

  const handleClose = () => {
    setShow(false);
    setCode('');
    setDefinition('');
  };

  const handleShow = () => {
    if (isEditMode && updatedJitaiVariable) {
      setCode(updatedJitaiVariable.code);
      setDefinition(updatedJitaiVariable.definition);
    }
    setShow(true);
  };

  const submitHandler = (e) => {
    e.preventDefault();
    if (isEditMode) {
      dispatch(
        updateJitaiVariable(studyId, updatedJitaiVariable._id, {
          code,
          definition,
        })
      );
    } else {
      dispatch(createJitaiVariable(studyId, { code, definition }));
    }
  };

  return (
    <>
      <Button variant='primary' className='btn-sm' onClick={handleShow}>
        {isEditMode ? 'Edit' : 'Add'}
      </Button>

      <Modal show={show} onHide={handleClose} size='lg'>
        <Modal.Header closeButton>
          <Modal.Title>
            {isEditMode ? 'Edit' : 'Add'} Jitai Variable
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {loadingCreate || loadingUpdate ? (
            <Loader />
          ) : (
            <Form onSubmit={submitHandler}>
              <Row>
                <Col md={12}>
                  <Form.Group controlId='code'>
                    <Form.Label>Code</Form.Label>
                    <Form.Control
                      type='text'
                      placeholder='Enter code'
                      value={code}
                      onChange={(e) => setCode(e.target.value)}
                      required
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Row className='mt-3'>
                <Col md={12}>
                  <Form.Group controlId='definition'>
                    <Form.Label>Definition</Form.Label>
                    <Form.Control
                      as='textarea'
                      rows={8}
                      placeholder='Enter how this variable shall be computed for developers to implement. If it is easier to illustrate with a formula or a table, you can put it into a shared Google Doc and paste the link of the doc here.'
                      value={definition}
                      onChange={(e) => setDefinition(e.target.value)}
                      required
                    />
                  </Form.Group>
                </Col>
              </Row>

              {errorCreate && <Message variant='danger'>{errorCreate}</Message>}
              {errorUpdate && <Message variant='danger'>{errorUpdate}</Message>}

              <div className='mt-3'>
                <Button
                  type='submit'
                  variant='primary'
                  style={{ marginRight: '12px' }}
                >
                  {isEditMode ? 'Update' : 'Create'}
                </Button>
                <Button variant='secondary' onClick={handleClose}>
                  Cancel
                </Button>
              </div>
            </Form>
          )}
        </Modal.Body>
      </Modal>
    </>
  );
};

export default UpsertJitaiVariable;
